import script from "./TarjetaHomeMejoresAgrupaciones.vue?vue&type=script&setup=true&lang=js"
export * from "./TarjetaHomeMejoresAgrupaciones.vue?vue&type=script&setup=true&lang=js"

import "./TarjetaHomeMejoresAgrupaciones.vue?vue&type=style&index=0&id=00dd16fc&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00dd16fc"]])

export default __exports__